<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="InvoiceEditor"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="invoice"
      autofocus="first"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetInvoiceHeader
        :formId="formId"
        :invoice="editor"
        :labelAlign="labelAlign"
      >
      </FieldsetInvoiceHeader>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      :disabled="!forms.invoice || !forms.invoice.submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class InvoiceEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  labelAlign!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  defaultTitle!: any;
  targetConfig!: any;
  editor!: any;

  async $$load_editor() {
    return this.invoice.editor()
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['labelAlign', 'formId', 'defaultTitle', 'targetConfig', 'editor', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "right",
        formId: null,
        defaultTitle: this.$fn.pgettext("Invoice", "Edit Invoice"),
        targetConfig: {
          header: {
            title: this.$fn.pgettext("Invoice", "Edit Invoice Header"),
            fieldsToSubmit: ["id"
              ,
              "revision_id"
              ,
              "etag"
              ,
              "company"
              ,
            ]
            ,
          }
          ,
        }
        ,
        editor: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.target ? this.targetConfig[this.target].title : this.defaultTitle,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3328_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3328, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_3334_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_3334, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_1040167445267876_crud_3332_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_3332, alias=save
    return {
      objectType: "invoice",
      op: "upsert",
      data: {
        ...this.editor.getChanges({ skipEmbeddedLists: true }),
        id: this.editor.id,
        etag: this.editor.etag
      },
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_3336_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_3336, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3328: actions.CloseModalAction;
    evh_7315092382398562_close_3327: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_3330: actions.CloseComponentAction;
    evh_2248226175642056_close_3329: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_3334: actions.CloseModalAction;
    evh_1040167445267876_success_3333: actions.EventHandlerImpl;
    act_1040167445267876_crud_3332: actions.CRUDAction;
    evh_1040167445267876_submit_3331: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_3336: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_3335: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3328 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3328_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3327 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3328,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3327],
      }
    );
    const act_2248226175642056_closeComponent_3330 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3329 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_3330,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3329],
      }
    );
    const act_1040167445267876_closeModal_3334 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_3334_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3333 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_3334,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_crud_3332 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_3332_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_3333],
      }
    );
    const evh_1040167445267876_submit_3331 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_3332,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_3331],
      }
    );
    const act_1419464017721962_closeModal_3336 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_3336_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_3335 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_3336,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_3335],
      }
    );
    return {
      act_7315092382398562_closeModal_3328,
      evh_7315092382398562_close_3327,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_3330,
      evh_2248226175642056_close_3329,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_3334,
      evh_1040167445267876_success_3333,
      act_1040167445267876_crud_3332,
      evh_1040167445267876_submit_3331,
      evh_1040167445267876_submit,
      act_1419464017721962_closeModal_3336,
      evh_1419464017721962_clickPreventStop_3335,
      evh_1419464017721962_clickPreventStop,
      save: act_1040167445267876_crud_3332,
    }
  }
}

Vue.component("InvoiceEditor", InvoiceEditor);

</script>